import { render, staticRenderFns } from "./HistoryAppBar.vue?vue&type=template&id=2531d60d&scoped=true&"
import script from "./HistoryAppBar.vue?vue&type=script&lang=js&"
export * from "./HistoryAppBar.vue?vue&type=script&lang=js&"
import style0 from "./HistoryAppBar.vue?vue&type=style&index=0&id=2531d60d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2531d60d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab})
